import { FC, useEffect } from 'react'

import { SearchOption } from '@joor/design-system'

type Props = {
  placeholder?: string
  setSearchText: (newSearchText: string) => void
}

export const FilterSearchBar: FC<Props> = ({ placeholder, setSearchText }) => {
  useEffect(() => {
    setSearchText('')
  }, [])

  return (
    <SearchOption
      placeholder={placeholder}
      onSearch={(event): void => setSearchText(event.searchText)}
    />
  )
}
